import { useCallback } from 'react';
import { useCurrencyContext } from '@components/Contexts/CurrencyContext';
import useFormattedCurrency from './useFormattedCurrency';

export const usePriceCalculation = () => {
  const {
    currencyData: { currencyCode, conversionRate },
    taxRate,
  } = useCurrencyContext();
  const { currencyConversionFormatter } = useFormattedCurrency({
    currency: currencyCode,
    conversionRate: conversionRate,
  });

  const getLocalizedTotalPrice = useCallback(
    (price: number, roundUp = true) => {
      const taxAddition = price * taxRate;
      const priceForIncludedCountries = price + taxAddition;
      return currencyConversionFormatter(priceForIncludedCountries, roundUp);
    },
    [taxRate],
  );

  return {
    getLocalizedTotalPrice,
  };
};
